export enum UserDetailSectionEnum {
  Personal = 'personal',
  Locations = 'locations',
  HolidaysEmail = 'holidays-email',
  Notifications = 'notifications',
  Chats = 'chats',
  Oauth = 'oauth',
  Contract = 'contract',
}

export const UserDetailSectionEnumLabels: Record<UserDetailSectionEnum, string> = {
  [UserDetailSectionEnum.Personal]: 'Datos personales',
  [UserDetailSectionEnum.Locations]: 'Ubicaciones',
  [UserDetailSectionEnum.HolidaysEmail]: 'Correo de vacaciones',
  [UserDetailSectionEnum.Notifications]: 'Notificaciones',
  [UserDetailSectionEnum.Chats]: 'Chats',
  [UserDetailSectionEnum.Oauth]: 'OAuth',
  [UserDetailSectionEnum.Contract]: 'Contrato',
};
